import axios from 'axios';

export default class ArticleListing {
  constructor() {
    this.$el = document.querySelector('.js-article-listing');
    if (!this.$el) return;

    this.currentPage = 1;

    this.$header = document.querySelector('.js-header');
    this.$loadMoreButton = this.$el.querySelector('.js-article-listing-load-more');
    this.$grid = this.$el.querySelector('.js-article-listing-grid');

    this.$categorySelect = this.$el.querySelector('.js-article-listing-category-select');
    this.$typeSelect = this.$el.querySelector('.js-article-listing-type-select');
    this.$numberOfVisibleArticles = this.$el.querySelector('.js-article-listing-visible-articles');
    this.$totalArticles = this.$el.querySelector('.js-article-listing-total-articles');
    this.$resetButton = this.$el.querySelector('.js-article-listing-reset-filters');

    this.$categorySelect?.addEventListener('change', this.filterByCategory.bind(this));
    this.$typeSelect?.addEventListener('change', this.onTypeSelect.bind(this));

    if (this.$loadMoreButton) {
      this.$loadMoreButtonText = this.$loadMoreButton.querySelector('.c-cta__label');
      this.originalLoadMoreButtonText = this.$loadMoreButtonText.innerText;
      this.$loadMoreButton.addEventListener('click', this.loadMore.bind(this));
    }

    if (this.$resetButton) {
      this.$resetButton.addEventListener('click', this.resetFilters.bind(this));
    }

    this.updateResetFilters();
  }

  async execute(params, scrollToTop = true, reset = false) {
    if (reset) {
      this.currentPage = 1;
    } else {
      this.currentPage++;
    }

    this.$grid.classList.add('is-loading');

    if (this.$loadMoreButton) {
      this.$loadMoreButtonText.innerText = 'Loading';
      this.$loadMoreButton.disabled = true;
    }

    const payload = new FormData;
    payload.append('paged', this.currentPage);

    Object.keys(params).forEach(key => {
      payload.append(key, params[key]);
    });

    let category = undefined;

    if (this.selectedCategory) {
      category = this.selectedCategory;
    } else if (this.$loadMoreButton && this.$loadMoreButton.dataset.category) {
      category = this.$loadMoreButton.dataset.category;
    }

    if (category) {
      payload.append('category', category);
    }

    if (this.$el.dataset.postType === 'post')  {
      payload.append('action', 'theme_articles_load_more');
    }

    if (this.$el.dataset.postType === 'webinars')  {
      payload.append('action', 'theme_webinars_load_more');
    }

    if (this.$el.dataset.postType === 'guides')  {
      payload.append('action', 'theme_guides_load_more');
    }

    try {
      const { data } = await axios.post(window.site.api.ajax, payload);

      if (this.$loadMoreButton) {
        this.$loadMoreButtonText.innerText = this.originalLoadMoreButtonText;
        this.$loadMoreButton.disabled = false;

        if (data.is_last_page) {
          this.$loadMoreButton.style.display = 'none';
        } else {
          this.$loadMoreButton.style.display = 'block';
        }
      }

      if (data) {
        this.$grid.innerHTML = reset ? data.response : this.$grid.innerHTML + data.response;
        this.$grid.classList.remove('is-loading');
        this.updateTotal(data.total_articles, scrollToTop);
        this.updateResetFilters();
      } else {
        if (this.$loadMoreButton) {
          this.$loadMoreButton.style.display = 'none';
        }

        this.updateResetFilters();
      }
    } catch (error) {
      this.currentPage = 1;
      this.$grid.classList.remove('is-loading');
    }
  }

  async loadMore() {
    const payload = {}

    if (this.selectedCategory) {
      payload['category'] = this.selectedCategory;
    }

    await this.execute(payload, false);
  }

  async filterByCategory(e) {
    const payload = {}

    if (e.target.value === 'all') {
      this.selectedCategory = undefined;
    } else {
      this.selectedCategory = e.target.value;
    }

    if (this.category) {
      payload['category'] = this.selectedCategory;
    }

    await this.execute(payload, true, true);
  }

  async resetFilters() {
    this.selectedCategory = undefined;
    this.$categorySelect.selectedIndex = 0;

    await this.execute({}, true, true);
  }

  updateTotal(totalArticles, scrollToTop = true) {
    const total = this.$grid.querySelectorAll('.js-article-card').length;

    this.$numberOfVisibleArticles.innerText = total;
    this.$totalArticles.innerText = totalArticles;
    this.$grid.classList.remove('is-loading');

    if (scrollToTop) {
      window.scrollTo({
        top: this.$el.offsetTop - this.$header.offsetHeight,
        behavior: 'smooth'
      });
    }
  }

  updateResetFilters() {
    if (!this.$resetButton) return;

    if (this.currentPage > 1 || this.selectedCategory) {
      this.$resetButton.style.display = 'block';
    } else {
      this.$resetButton.style.display = 'none';
    }
  }

  onTypeSelect(e) {
    window.location = e.currentTarget.value;
  }
}
